<div fxLayout='column' fxLayoutAlign="space-between stretch" class="email-div">
  <h3 fxFlex='9'>Email</h3>
  <mat-form-field *ngIf='groupId || groupEventId' style='width:100%' fxFlex='9'>
    <mat-label>From</mat-label>
    <mat-select placeholder='From' [(ngModel)]='senderEmail' required>
      <mat-option *ngFor='let admin of groupAdmins' [value]='admin.email'>
        {{admin.first}} {{admin.last}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field style='width:100%' *ngIf='playerId' fxFlex='9'>
    <mat-label>From</mat-label>
    <input matInput placeholder='From' [(ngModel)]='player.email' disabled>
  </mat-form-field>
  <mat-form-field style='width:100%' fxFlex='9'>
    <mat-label>Subject</mat-label>
    <input matInput placeholder='Subject' [(ngModel)]='subject' required>
  </mat-form-field>
  <div fxFlex="1 1 100%">
    <ckeditor [(ngModel)]="htmlContent" [editor]="Editor"></ckeditor>
  </div>
  <div class='warn-color' *ngIf='message' fxFlex='9'>{{message}}</div>
  <div fxFlex='9'>
    <button mat-raised-button color='primary' (click)='send()'>Send
      <i class='fa fa-spinner fa-spin' *ngIf='sending'></i>
    </button>
  </div>
</div>